const isEmptyValue = (value) => value === null || value === undefined || value === '';

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const isEmptyNormalizedValue = (value) =>
  isEmptyValue(value) ||
  (Array.isArray(value) && value.length === 0) ||
  (isPlainObject(value) && Object.keys(value).length === 0);

export const omitEmptyOptionalSchemaProperties = (payload, schema = {}) => {
  if (Array.isArray(payload)) {
    return payload.map((item) => omitEmptyOptionalSchemaProperties(item, schema.items || {}));
  }

  if (!isPlainObject(payload) || !isPlainObject(schema.properties)) return payload;

  const requiredProperties = new Set(Array.isArray(schema.required) ? schema.required : []);

  return Object.entries(payload).reduce((result, [key, value]) => {
    const propertySchema = schema.properties[key];
    if (!propertySchema) {
      result[key] = value;
      return result;
    }

    if (!requiredProperties.has(key) && isEmptyValue(value)) return result;

    const normalizedValue = omitEmptyOptionalSchemaProperties(value, propertySchema);
    if (!requiredProperties.has(key) && isEmptyNormalizedValue(normalizedValue)) return result;

    result[key] = normalizedValue;
    return result;
  }, {});
};
